import { Injectable, inject, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserAuthService } from 'app/core/user/user.service';

export interface Credentials {
    tokens: any;
    data: any[];
    user: any;
    role: string;
    company: Object;
    isCoupa: boolean;
    coupaURL: string;
    reservation_allowed: boolean;
    buyerCookie: string;
    clientId?: string;
}

export interface CredentialsCurrentUser {
    name: string;
    email: string;
    role: string;
    id: string;
    company: any;
    coupaUrl: string;
    isCoupa: boolean;
    buyerCookie: string;
    clientId?: string;
    brandId?: string;
    avatar?: string;
    status?: string;
    /** Grupo Dirección ({@link GROUPS.MANAGEMENT}). */
    isManagement?: boolean;
    isAdministration?: boolean;
}

@Injectable({ providedIn: 'root' })
export class CredentialsService {
    private _credentials = signal<Credentials>(null);
    private _credentialsCurrentUser = signal<CredentialsCurrentUser>(null);
    private _userAuthService = inject(UserAuthService);
    static credentialsCurrentUser: string;

    constructor() {
        // Las credenciales se manejan a través del sistema de Cognito (sin localStorage)
        this._userAuthService.user$.subscribe(
            (user: CredentialsCurrentUser) => {
                this._credentialsCurrentUser.set(user);
            }
        );
    }

    get credentials(): Credentials | null {
        return this._credentials();
    }

    get credentialsCurrentUser(): CredentialsCurrentUser | null {
        return this._credentialsCurrentUser();
    }

    /*get role(): string {
        return this._credentials()?.user['role'];
    }*/

    isAuthenticated(): Observable<boolean> {
        return of(!!this.credentials);
    }

    removeCredentials() {
        // Solo limpiar el currentUser, no usar localStorage
        this._credentials.set(null);
        this._credentialsCurrentUser.set(null);
        this._userAuthService.user = null;
    }

    setCredentials(credentials: Credentials, remember: boolean) {
        this._credentials.set(credentials);

        // No guardar en localStorage, solo configurar en memoria
        if (credentials && credentials.user) {
            const currentUser = this.buildCurrentUserFromCredentials(
                credentials
            );
            if (currentUser) {
                this._credentialsCurrentUser.set(currentUser);
                this._userAuthService.user = currentUser;
            }
        } else {
            this.removeCredentials();
        }
    }

    private buildCurrentUserFromCredentials(
        credentials: Credentials
    ): CredentialsCurrentUser | null {
        const storedUser = credentials?.user;
        if (!storedUser || !credentials.role) {
            return null;
        }

        return {
            id: storedUser.id ?? storedUser.sub,
            name: storedUser.name,
            email: storedUser.email,
            role: credentials.role,
            clientId: credentials.clientId ?? storedUser.companyId,
            brandId: storedUser.brandId,
            isCoupa: credentials.isCoupa ?? false,
            company: credentials.company,
            coupaUrl: credentials.coupaURL ?? null,
            buyerCookie: credentials.buyerCookie ?? null,
            isManagement: !!storedUser.isManagement,
            isAdministration: !!storedUser.isAdministration
        };
    }
}
